"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapInputWindow = void 0;
require("../../../../node_modules/leaflet/dist/leaflet.css");
const Utilities_1 = require("../../../javascript/Utilities");
const ExternalInput_1 = require("./ExternalInput");
const Base_1 = require("../../../model/Base");
let L = require("../../../../node_modules/leaflet/dist/leaflet.js");
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("../../../../node_modules/leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("../../../../node_modules/leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("../../../../node_modules/leaflet/dist/images/marker-shadow.png")
});
/**
* Map input window (cefunc.207)
*/
class MapInputWindow extends ExternalInput_1.ExternalInput {
    constructor(controlColl, currentInstance, methodName) {
        super(controlColl, currentInstance, methodName);
        this.methodName = methodName;
        this.windowWidth = 800;
        this.windowHeight = 600;
        this.windowContentCssClass = "eiMapInputWindow";
        this.windowActions = ["Maximize", "Close"];
        this.needServerConfig = true;
    }
    getUpdatedInstance() {
        let that = this;
        let updatedInstance = that.currentInstance;
        if (that.newMarker != undefined) {
            updatedInstance.items[that.latitudeFieldName].value = that.newMarker.getLatLng().lat;
            updatedInstance.items[that.longitudeFieldName].value = that.newMarker.getLatLng().lng;
        }
        return Promise.resolve(updatedInstance);
    }
    initWindowContents() {
        let that = this;
        // Set field names
        that.latitudeFieldName = that.input.field.fieldName;
        that.longitudeFieldName = that.latitudeFieldName.replace(/lat$/, "lng");
        // Create dialog
        let dialog = that.windowData.windowDiv.data("kendoWindow");
        dialog.setOptions({
            resizable: true,
            minWidth: that.windowMinWidth == undefined ? that.windowWidth : that.windowMinWidth,
            minHeight: that.windowMinHeight == undefined ? that.windowHeight : that.windowMinHeight
        });
        // Create map
        let mapId = "map_" + Utilities_1.synUtil.getGUID(true);
        let $div = $("<div></div>")
            .css({
            "height": "100%",
            "width": "calc(100% - .58em)",
        })
            .attr({
            "id": mapId
        })
            .appendTo(that.widgetContainer);
        let map = L.map(mapId, { worldCopyJump: true }).setView([47.8095, 13.0550], 3);
        // Load tiles
        let mapboxAccessToken = "";
        if (typeof that.serverConfig["mapboxaccesstoken"] !== "undefined")
            mapboxAccessToken = that.serverConfig["mapboxaccesstoken"];
        if (mapboxAccessToken === "") {
            let osmUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
            let osmAttrib = 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors';
            let tileMap = new L.TileLayer(osmUrl, { minZoom: 2, maxZoom: 19, attribution: osmAttrib });
            map.addLayer(tileMap);
            that.minZoom = 2;
            that.maxZoom = 19;
        }
        else {
            L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
                attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
                minZoom: 2,
                maxZoom: 20,
                tileSize: 512,
                zoomOffset: -1,
                id: 'streets-v10',
                accessToken: mapboxAccessToken
            }).addTo(map);
            that.minZoom = 2;
            that.maxZoom = 20;
        }
        // Get map zoom level
        let mapZoom = 0;
        if (typeof that.serverConfig["mapzoom"] !== "undefined")
            mapZoom = parseInt(that.serverConfig["mapzoom"]);
        if (mapZoom > that.maxZoom)
            mapZoom = that.maxZoom;
        if (mapZoom < that.minZoom)
            mapZoom = that.minZoom;
        // Add marker function
        function addMarker(lat, lng, iconDocId) {
            if (iconDocId) {
                let customIcon = L.icon({
                    iconUrl: Utilities_1.synUtil.getWSUrl("Icon") + "docid=" + iconDocId + "/32",
                    iconSize: [32, 32],
                    iconAnchor: [16, 16],
                    popupAnchor: [0, -10],
                });
                that.newMarker = L.marker([lat, lng], { icon: customIcon }).addTo(map);
            }
            else
                that.newMarker = L.marker([lat, lng]).addTo(map);
        }
        // Add marker if coordinates are already available
        let latitude = that.currentInstance.items[that.latitudeFieldName].value;
        let longitude = that.currentInstance.items[that.longitudeFieldName].value;
        if (latitude != undefined && longitude != undefined) {
            let mapMarkerIconField = that.serverConfig["mapmarkericonfield"];
            let mapMarkerIconDocId = "";
            if (typeof that.currentInstance.items[mapMarkerIconField] !== "undefined")
                mapMarkerIconDocId = that.currentInstance.items[mapMarkerIconField].valueAsString;
            addMarker(latitude, longitude, mapMarkerIconDocId);
            map.setView(that.newMarker.getLatLng(), mapZoom);
        }
        else {
            let mapCenterLatFieldName = that.serverConfig["mapcenterlatfield"];
            if (typeof that.currentInstance.items[mapCenterLatFieldName] !== "undefined") {
                let mapCenterLngFieldName = mapCenterLatFieldName.replace(/lat$/, "lng");
                let locationLat = that.currentInstance.items[mapCenterLatFieldName].value;
                let locationLng = that.currentInstance.items[mapCenterLngFieldName].value;
                if (locationLat != undefined && locationLng != undefined)
                    map.setView([locationLat, locationLng], mapZoom);
            }
        }
        function onMapClick(e) {
            if (that.newMarker)
                map.removeLayer(that.newMarker);
            let mapMarkerIconField = that.serverConfig["mapmarkericonfield"];
            let mapMarkerIconDocId = "";
            if (typeof that.currentInstance.items[mapMarkerIconField] !== "undefined")
                mapMarkerIconDocId = that.currentInstance.items[mapMarkerIconField].valueAsString;
            addMarker(e.latlng.lat, e.latlng.lng, mapMarkerIconDocId);
        }
        // Add marker on click
        if (!(that.mode === Base_1.PropertyPageMode.View || (that.input && that.input.readonlyForExtInput)))
            map.on("click", onMapClick);
        return Promise.resolve();
    }
}
exports.MapInputWindow = MapInputWindow;
